import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchReaderBonusList
} from '../../modules/readerBonus';

export class ReaderBonusOverview extends Component {
  componentDidMount() {
    const accountId = this.props.userProfile?.account?._id;
    if (accountId && this.props.idToken) {
      this.fetchReferrals(accountId);
    }
  }

  componentDidUpdate(previousProps) {
    const accountId = this.props.userProfile?.account?._id;
    const previousAccountId = previousProps.userProfile?.account?._id;
    if (accountId && this.props.idToken &&
      (accountId !== previousAccountId || this.props.idToken !== previousProps.idToken)) {
      this.fetchReferrals(accountId);
    }
  }

  fetchReferrals = (accountId) => {
    const { idToken } = this.props;
    this.props.fetchReaderBonusList(idToken, accountId);
  }

  render() {
    const {
      userProfile, user, t, readerBonusList
    } = this.props;
    if (!user || !userProfile) return null;
    let readerLimit = userProfile.maxReadersPerBook;
    if (readerLimit === -1) {
      // reader limit should be unlimited
      readerLimit = 'max';
    }
    return (
      <section>
        <h2>{t('RaiseYourReaderLimit', { x: readerLimit })}</h2>
        <div style={{ overflowX: 'auto' }}>
          <table className='br-table'>
            <thead>
              <tr>
                <th scope='col'>{t('Type')}</th>
                <th scope='col'>{t('Description')}</th>
                <th scope='col'>{t('Status')}</th>
              </tr>
            </thead>
            <tbody>
              {
                readerBonusList && readerBonusList.map((bonusEntry, index) => (
                  <tr key={bonusEntry._id || `${bonusEntry.type}-${index}`}>
                    <td>{t(`referral-type_${bonusEntry.type}`)}</td>
                    <td>{bonusEntry.description || t('Unnamed')}</td>
                    <td>
                      {
                        bonusEntry.type === 'READ_AND_REVIEW' && (
                          <span>
                            {`${Number(bonusEntry.status * 100).toFixed(2)}%`}
                            {
                              bonusEntry.status === 1 && (
                                <span aria-label={t('Done')} style={{ float: 'right', color: 'var(--br-accent)' }}>✓</span>
                              )
                            }
                          </span>
                        )
                      }
                      {
                        ['REFERRAL', 'SIGNUP_BONUS'].includes(bonusEntry.type) && (
                          <span>
                            {t(bonusEntry.status)}
                            {
                              bonusEntry.status === 'CONFIRMED' && (
                                <span aria-label={t('Done')} style={{ float: 'right', color: 'var(--br-accent)' }}>✓</span>
                              )
                            }
                          </span>
                        )
                      }
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <p style={{ fontSize: '0.8em' }}>
          {t('ReadAndReviewBonusInfo')}
        </p>
      </section>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  readerBonusList: state.readerBonus.readerBonusList
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchReaderBonusList
}, dispatch);

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(ReaderBonusOverview));
